import { MapPin } from "lucide-react";
import { fmtDate } from "@/lib/api";

export function Timeline({ events }) {
  const list = [...(events || [])].sort((a, b) => new Date(b.timestamp) - new Date(a.timestamp));
  return (
    <ol className="relative" data-testid="tracking-timeline">
      {list.map((e, i) => (
        <li key={e.id || i} className="relative pl-8 pb-8 last:pb-0" data-testid={`timeline-event-${i}`}>
          {i < list.length - 1 && <span className="absolute left-[7px] top-4 bottom-0 w-px bg-slate-200" />}
          <span className={`absolute left-0 top-1 h-4 w-4 rounded-full border-2 ${i === 0 ? "bg-[#FF6B00] border-[#FF6B00] pulse-dot" : "bg-white border-slate-300"}`} />
          <p className={`font-display font-semibold ${i === 0 ? "text-[#0A192F]" : "text-slate-700"}`}>{e.status}</p>
          <p className="text-sm text-slate-600 flex items-center gap-1 mt-0.5"><MapPin className="h-3.5 w-3.5" /> {e.location}</p>
          {e.note && <p className="text-sm text-slate-500 mt-1">{e.note}</p>}
          <p className="text-xs font-mono text-slate-400 mt-1">{fmtDate(e.timestamp)}</p>
        </li>
      ))}
    </ol>
  );
}
